const baseUrl = import.meta.env.VITE_API_BASE_URL;
const env = import.meta.env.VITE_ENV || 'local'

const config = {
  apiUrl: baseUrl,
  environment: env,
  inProduction: env === 'production',
  inTest: env === 'test',
  inDevelop: env === 'development' || env === 'develop' || env === 'dev',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  version: import.meta.env.VITE_APP_VERSION,
  appUrl: import.meta.env.VITE_APP_URL,
};

console.log('API URL:', config.apiUrl);
console.log('Environment:', config.environment);


if (!config.apiUrl) {
  throw new Error("CRITICAL: VITE_API_BASE_URL is not defined in your .env file! Please create a .env file and add the variable.");
}

if (!config.appUrl) {
  throw new Error("CRITICAL: VITE_APP_URL is not defined in your .env file! Please create a .env file and add the variable.");
}

export default config;